import moment from 'moment';
import { createAsyncAction } from 'react-redux-await-control';
import { message } from 'antd';

import { telli } from '~/services';
import { handleBusinessErrors } from '~/common/utils/errorHandler';

const normalizeBirthDate = (contract) => ({
  ...contract,
  birthDate: contract?.birthDate ? moment(contract.birthDate).endOf('day').toDate() : null,
});

export const sendContract = createAsyncAction('CONSIGNEE_SEND_CONTRACT', {
  saveResult: true,
  context: {
    request: ({ contractId, data }) => {
      const normalizedData = normalizeBirthDate(data);
      return telli.post(`/admin/contractcustom/contracts/${contractId}/sendtoconsignee`, normalizedData);
    },
    onRequestSuccess: () => message.success('Contrato enviado com Sucesso!'),
    // Mostra a mensagem do telli quando houver (ex.: CEP fora da base dos Correios).
    onRequestError: (err) => handleBusinessErrors(err, { defaultMessage: 'Falha ao enviar contrato' }),
  },
});

export const updateConsigneeStatus = createAsyncAction('UPDATE_CONSIGNEE_STATUS', {
  saveResult: true,
  context: {
    request: ({ contractId }) => telli.post(`/admin/contractcustom/contracts/${contractId}/updateconsigneestatus`),
    onRequestError: () => {},
  },
});
